import React from 'react';
import { PermissionName } from './permissionsConstants';
import { usePermission } from '../../hooks/usePermission';
import { checkPermission } from '../../utils/permissionUtils';

interface PermissionGuardProps {
  /**
   * needed permission(single or multiple)
   */
  permission?: PermissionName | PermissionName[];

  /**
   * needed any permission(multiple permissions)
   */
  anyPermission?: PermissionName[];

  /**
   * needed all permissions(multiple permissions)
   */
  allPermissions?: PermissionName[];

  /**
   * content to render when has permission
   */
  children: React.ReactNode;

  /**
   * content to render when no permission(optional)
   */
  fallback?: React.ReactNode;

  /**
   * whether to render null when no permission(default true)
   */
  hideOnNoPermission?: boolean;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  permission,
  anyPermission,
  allPermissions,
  children,
  fallback = null,
  hideOnNoPermission = true
}) => {
  const {
    hasPermission,
    hasAnyPermission: checkAnyPermission,
    hasAllPermissions: checkAllPermissions
  } = usePermission();

  // Use unified permission check function
  const hasAccess = checkPermission({
    permission,
    anyPermission,
    allPermissions,
    hasPermission,
    hasAnyPermission: checkAnyPermission,
    hasAllPermissions: checkAllPermissions
  });

  if (hasAccess) {
    return <>{children}</>;
  }

  if (hideOnNoPermission) {
    return <>{fallback}</>;
  }

  return null;
};

export default PermissionGuard;

